import {put} from '../utils'
import {root} from './utils'

export default host => (forecasts) =>
  put(`${host}${root}`, JSON.stringify(forecasts))
